import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TwoFactorEnum } from '../../settings/enum/settings-type.enum';

@Component({
  selector: 'app-two-factor',
  templateUrl: './two-factor.component.html',
  styleUrls: ['./two-factor.component.scss'],
})
export class TwoFactorComponent implements OnInit, OnDestroy {
  // FormGroup is defined
  twoFactorForm: FormGroup;
  inputDigitLeft: string = 'Verify code';
  btnStatus: string = 'btn-light';
  timeLeft: number = 180;
  @Input() beginningTime: number = 180;
  timerInterval: any;
  @Input() verificationType: TwoFactorEnum | null;
  @Output() resendCodeOn = new EventEmitter<void>();
  @Output() sendCodeOn = new EventEmitter<{ code: string }>();
  @Output() goBackOn = new EventEmitter<void>();

  // Input fields are referenced using ViewChild
  @ViewChild('otp1Input') otp1Input!: ElementRef;
  @ViewChild('otp2Input') otp2Input!: ElementRef;
  @ViewChild('otp3Input') otp3Input!: ElementRef;
  @ViewChild('otp4Input') otp4Input!: ElementRef;
  @ViewChild('otp5Input') otp5Input!: ElementRef;
  @ViewChild('otp6Input') otp6Input!: ElementRef;

  constructor(
    private readonly fb: FormBuilder
  ) {
    // FormGroup is created using FormBuilder
    this.twoFactorForm = this.fb.group({
      otp1: ['', Validators.required],
      otp2: ['', Validators.required],
      otp3: ['', Validators.required],
      otp4: ['', Validators.required],
      otp5: ['', Validators.required],
      otp6: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startTimer() {
    this.timeLeft = this.beginningTime;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  // Function called when the value of each input field changes
  onOtpChange(index: number, event: any) {
    const inputValue = event.target.value;
    if (inputValue.length === 1) {
      if (index < 6) {
        this.setFocus(index + 1);
      }
      this.checkOtp();
    } else if (inputValue.length === 0 && index > 1) {
      this.setFocus(index - 1);
      this.checkOtp();
    }
  }

  // Function to switch focus between input fields
  setFocus(index: number) {
    switch (index) {
      case 1:
        this.otp1Input.nativeElement.focus();
        break;
      case 2:
        this.otp2Input.nativeElement.focus();
        break;
      case 3:
        this.otp3Input.nativeElement.focus();
        break;
      case 4:
        this.otp4Input.nativeElement.focus();
        break;
      case 5:
        this.otp5Input.nativeElement.focus();
        break;
      case 6:
        this.otp6Input.nativeElement.focus();
        break;
      default:
        break;
    }
  }

  // Function to check the validity of entered OTP
  checkOtp() {
    const otpArray = [
      this.twoFactorForm.get('otp1')?.value,
      this.twoFactorForm.get('otp2')?.value,
      this.twoFactorForm.get('otp3')?.value,
      this.twoFactorForm.get('otp4')?.value,
      this.twoFactorForm.get('otp5')?.value,
      this.twoFactorForm.get('otp6')?.value,
    ];
    const otp = otpArray.join('');
    if (otp.length === 6) {
      this.btnStatus = 'btn-primary';
    } else {
      this.btnStatus = 'btn-light';
    }
  }

  resendCode() {
    this.resendCodeOn.emit();
    this.startTimer();
  }

  verifyCode() {
    const otp1 = this.twoFactorForm.get('otp1')?.value;
    const otp2 = this.twoFactorForm.get('otp2')?.value;
    const otp3 = this.twoFactorForm.get('otp3')?.value;
    const otp4 = this.twoFactorForm.get('otp4')?.value;
    const otp5 = this.twoFactorForm.get('otp5')?.value;
    const otp6 = this.twoFactorForm.get('otp6')?.value;
    const fullCode = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    this.sendCodeOn.emit({ code: fullCode });
  }

  goBack() {
    this.goBackOn.emit();
  }
}
